var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "multi-selector" }, _vm._l(_vm.selectList, function (item, index) {
    return _c('div', { key: index, staticClass: "selector" }, [_c('el-select', _vm._b({ on: { "change": _vm.handleChange }, model: { value: item.value, callback: function callback($$v) {
          _vm.$set(item, "value", $$v);
        }, expression: "item.value" } }, 'el-select', _vm.innerConfig.params, false), _vm._l(_vm.innerConfig.params.options, function (item) {
      return _c('el-option', { key: item.value, attrs: { "label": item.label, "value": item.value } });
    }), 1), _vm._v(" "), index === 0 ? _c('el-button', { attrs: { "circle": "", "icon": "el-icon-plus" }, on: { "click": _vm.handleAdd } }) : _c('el-button', { attrs: { "circle": "", "icon": "el-icon-delete" }, on: { "click": function click() {
          _vm.handleDel(index);
        } } })], 1);
  }), 0);
};
var staticRenderFns = [];

export { render, staticRenderFns };